import pLimit from 'p-limit';

export async function runThreadPool<T, R>(
  items: T[],
  taskRunner: (item: T, index: number) => Promise<R>,
  maxConcurrent = 3
) {
  const hardware = typeof navigator !== 'undefined' ? navigator.hardwareConcurrency || 4 : 4;

  const safeConcurrent = Math.max(1, Math.min(maxConcurrent, hardware));

  const limit = pLimit(safeConcurrent);

  const tasks = items.map((item, index) => {
    return limit(async () => {
      // 内部通过 async/await 确保不管是同步报错还是异步报错都能被拦截
      return await taskRunner(item, index);
    });
  });

  // 3. 投喂给 Promise.all 齐头并进，p-limit 会在底层自动控制最大并发排队
  // 最终返回的结果顺序与输入的 items 顺序严格保持一致
  return await Promise.all(tasks);
  // return await Promise.allSettled(tasks);
}
